<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1311px"
      height="calc(100vh - 240px )"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="activityNo" label="编号" width="100" />
      <el-table-column
        prop="activityName"
        label="名称"
        width="200"
        class="sort"
      />
      <el-table-column prop="imgUrl" label="图片" width="200">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.imgUrl"
            fit="contain"
            style="width: 50px; height: 50px"
            :preview-src-list="toArrayEvent(scope.row.imgUrl)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="qrcodeUri" label="小程序码" width="200">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.qrcodeStatus === 0"
            :src="scope.row.qrcodeUri"
            fit="contain"
            style="width: 50px; height: 50px"
            :preview-src-list="toArrayEvent(scope.row.qrcodeUri)"
          />
        </template>
      </el-table-column>
      <el-table-column label="有效期" width="300">
        <template slot-scope="scope">
          {{ scope.row.effectiveStartTime }} ~ {{ scope.row.effectiveEndTime }}
        </template>
      </el-table-column>
      <el-table-column prop="gameName" label="游戏名称" width="200" />
      <el-table-column prop="gameType" label="游戏类型" width="100">
        <template slot-scope="scope">
          {{ scope.row.gameType === 1 ? "集章" : "抽奖" }}
        </template>
      </el-table-column>
      <el-table-column prop="qrcodeStatus" label="动态二维码" width="100">
        <template slot-scope="scope">
          <div
            :style="{ color: scope.row.qrcodeStatus ? '#67C23A' : '#e74c3c' }"
          >
            {{ scope.row.qrcodeStatus ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="是否启用" width="100">
        <template slot-scope="scope">
          <div :style="{ color: scope.row.status ? '#67C23A' : '#e74c3c' }">
            {{ scope.row.status ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '修改' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="名称">
          <el-input
            v-model="formData.activityName"
            placeholder="请输入名称"
            style="width: 200px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="图片">
          <div>
            <div>
              <uploadPic
                ref="uploadPic"
                :my-url="formData.imgUrl"
                :width="80"
                :height="80"
                @upLoadImage="upLoadImage"
              />
            </div>
            <div style="font-size: 12px; color: #909399;margin: 0 10px;">
              图片比例为3:1,最小为450px x 150px,尺寸不要超过300KB
            </div>
          </div>
        </el-form-item>
        <el-form-item label="游戏类型">
          <el-radio-group
            v-model="formData.gameType"
            :disabled="isEdit"
            @change="changeGameType"
          >
            <el-radio :label="1">集章</el-radio>
            <el-radio :label="2">抽奖</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="游戏名称">
          <el-select
            v-model="formData.gameId"
            placeholder="请选择游戏名称"
            :disabled="isEdit"
            style="width: 200px"
            size="mini"
            @change="changeGameItem($event)"
          >
            <el-option
              v-for="item in gameListOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            v-model="formData.effectiveStartTime"
            type="date"
            placeholder="开始日期"
            :disabled="isEdit"
            style="width: 200px"
          />
          <el-date-picker
            v-model="formData.effectiveEndTime"
            type="date"
            placeholder="结束日期"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="动态二维码">
          <el-radio v-model="formData.qrcodeStatus" :label="0">禁用</el-radio>
          <el-radio v-model="formData.qrcodeStatus" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio v-model="formData.status" :label="0">禁用</el-radio>
          <el-radio v-model="formData.status" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-right: 10px"
            @click="dialogVisible = false"
          >取消</el-button>
          <el-popconfirm
            title="确定添加？"
            @onConfirm="isEdit ? edit() : add()"
          >
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >保存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
// import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import newUploadImage from '@/components/Upload/newUploadImage' // 上传图片
import environment from '@/utils/environment'
// Default SortableJS
import Sortable from 'sortablejs'
import {
  getActivityManList,
  addActivityMan,
  updateActivityMan,
  sortActivityMan,
  removeActivityMan
} from '@/api/activity/activityMan.js'
import { parseTime } from '@/utils'
import { getPointConfigList } from '@/api/activity/pointConfig'
import { getAwardManList } from '@/api/activity/awardMan'

export default {
  name: 'Order',
  components: { uploadPic },
  data() {
    return {
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      formData: {
        activityName: '',
        imgUrl: '',
        effectiveStartTime: '',
        effectiveEndTime: '',
        gameType: 1,
        gameId: '',
        gameName: '',
        qrcodeStatus: 1,
        status: 1
      }, // 选中项
      isEdit: false,
      config: {
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: 700,
        maximumWords: 9999999,
        // 上传文件接口
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '' /* 图片访问路径前缀 */,
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10 // 单位B 10MB
      },
      sortable: null,
      gameListOption: [],
      pointConfigList: [],
      awardManList: []
    }
  },
  mounted() {
    this.getList()

    getPointConfigList().then((res) => {
      this.pointConfigList = res
    })
    getAwardManList().then((res) => {
      this.awardManList = res
    })
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    // 图片上传回调
    upLoadImage(url) {
      this.formData.imgUrl = url
    },
    // 获取表单信息
    getList() {
      this.loading = true
      getActivityManList()
        .then((res) => {
          this.showtabelData = res
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      // console.log(11)
      this.active = {}
    },
    initData() {
      this.formData = {
        activityName: '',
        imgUrl: '',
        effectiveStartTime: '',
        effectiveEndTime: '',
        gameType: 1,
        gameName: '',
        qrcodeStatus: 1,
        status: 1,
        gameId: ''
      }
    },
    open(type, item) {
      console.log(type, item)
      this.initData()
      if (type == 'add') {
        this.isEdit = false
        setTimeout(() => {
          this.$refs.uploadPic.init('')
        }, 0)
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.isEdit = true
        this.formData = { ...this.formData, ...item }
        this.dialogVisible = true
      }

      this.gameListOption = []
      if (this.formData.gameType === 1) {
        this.pointConfigList.forEach((item) => {
          this.gameListOption.push({
            label: item.name,
            value: item.id
          })
        })
      }
      if (this.formData.gameType === 2) {
        this.awardManList.forEach((item) => {
          this.gameListOption.push({
            label: item.awardName,
            value: item.id
          })
        })
      }
    },
    // 添加
    add() {
      this.formData.effectiveStartTime = parseTime(
        this.formData.effectiveStartTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        this.formData.effectiveEndTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      console.log(this.formData)
      addActivityMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      this.formData.effectiveStartTime = parseTime(
        this.formData.effectiveStartTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        this.formData.effectiveEndTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      updateActivityMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('修改成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 批量删除
    bulkDelete() {
      console.log(this.multipleSelection, 'this.multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        })
          .then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id
            })
            removeActivityMan({ ids })
              .then((res) => {
                this.$message.success('删除成功')
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message.warning('请勾选要删除的选项')
      }
    },
    changeGameItem(itemid) {
      this.formData.gameName = this.gameListOption.find(
        (item) => item.value === itemid
      )?.label
    },
    changeGameType(item) {
      console.log(item)
      this.formData.gameType = item
      this.formData.gameId = ''
      this.gameListOption = []
      if (this.formData.gameType === 1) {
        this.pointConfigList.forEach((item) => {
          this.gameListOption.push({
            label: item.name,
            value: item.id
          })
        })
      }
      if (this.formData.gameType === 2) {
        this.awardManList.forEach((item) => {
          this.gameListOption.push({
            label: item.awardName,
            value: item.id
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head_search {
  display: flex;
  // justify-content: space-around;
  width: 100%;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
